<section class="productDetailsSection">
  <header>
    <h3>{{title}}</h3>
  </header>
  <div [innerHTML]="safeContent"></div>
</section>
